import "./App.css";
// import SingleProductPage from "./Components/Pages/SingleProductPage";
// import BeautyProducts from "./Components/Pages/BeautyProducts";
import AllRoutes from "./Routes/AllRoutes";

// import MainSlider from "./Components/Crousel/MainSlider"
function App() {
  return (
    <div className="App">
      <AllRoutes />
      {/* <SingleProductPage/> */}
   
    </div>
  );
}

export default App;
